import { render, staticRenderFns } from "./add-item.vue?vue&type=template&id=2d2135ae&"
import script from "./add-item.vue?vue&type=script&lang=ts&"
export * from "./add-item.vue?vue&type=script&lang=ts&"
import style0 from "./add-item.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports